import { z } from 'zod';
import { oneOf, pageNum, pageSize, str } from '../../navigation/searchParams';

/** The edit and history dialogs, and the history table's paging. */
export const phoneNumbersSearch = z.object({
  modal: oneOf(['edit-number', 'number-history']),
  id: str,
  historyPage: pageNum,
  historySize: pageSize,
});
